let lockCount = 0;
let overflowBeforeLock = "";

export function acquireBodyScrollLock() {
  if (lockCount === 0) {
    overflowBeforeLock = document.body.style.overflow;
  }

  lockCount += 1;
  document.body.style.overflow = "hidden";

  let released = false;
  return () => {
    if (released) {
      return;
    }

    released = true;
    lockCount -= 1;
    if (lockCount === 0) {
      document.body.style.overflow = overflowBeforeLock;
    }
  };
}
